import { backendApi } from '_config';
import defaultAxios from 'axios';

const Api = defaultAxios.create({
  baseURL: backendApi,
  withCredentials: true,
});

Api.interceptors.request.use((config) => {
  const token = localStorage.getItem('userAuthToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

Api.interceptors.response.use(
  (response) => response,
  (error) => {
    const response = error.response?.data;
    if (!response) {
      return Promise.reject('Unexpected error');
    }
    return Promise.reject(response);
  },
);

export default Api;
